import { GridsterItem } from 'angular-gridster2';
import { IBrickDescription } from '../../../../store/dashboard/brick-wall/brick-instances/brick-instances.state';
import { BrickLayoutType } from '../../../../samwebDescription/samweb/dashboard/brickLayoutType';
import _ from 'lodash';

export function mapBrickInstanceToGridster(isEditable: boolean, isPilotPanelExtended: boolean, instance: IBrickDescription): GridsterItem {
   const minRows = instance.definition.minRowHeight;
   const minCols = instance.brickInstance.brickLayout.value === BrickLayoutType.PILOT_PANEL.value ? 1 : instance.definition.minColWidth;
   let rows = instance.brickInstance.rowHeight >= instance.definition.minRowHeight ? instance.brickInstance.rowHeight : minRows;
   let cols = instance.brickInstance.colWidth >= instance.definition.minColWidth ? instance.brickInstance.colWidth : minCols;

   if (instance.brickInstance.brickLayout.value === BrickLayoutType.PILOT_PANEL.value) {
      cols = 1;
   }

   if (instance.brickInstance.brickLayout.value === BrickLayoutType.PILOT_PANEL.value && !isPilotPanelExtended) {
      if (!_.isNil(instance.definition.collapsedRowHeight)) {
         rows = instance.definition.collapsedRowHeight;
      }
      isEditable = false;
   }

   return <GridsterItem>{
      brickInstanceId: instance.brickInstance.brickInstanceId,
      dragEnabled: isEditable,
      resizeEnabled: isEditable,
      x: instance.brickInstance.positionX,
      y: instance.brickInstance.positionY,
      minCols: minCols,
      minRows: minRows,
      cols: cols,
      rows: rows,
   };
}
